import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { errMsg } from '../porters/porterUi';

const FIELDS = [
  ['collection_threshold', 'Collection distance threshold (miles from reference)', 'number'],
  ['outward_threshold', 'Additional outward distance threshold (miles)', 'number'],
  ['exception_min_quote', 'Minimum quote value for exception (£, applies when quote is strictly above)', 'number'],
  ['reference_postcode', 'Yard postcode (quotes + calendar)', 'text'],
];

export const QuoteSettings = ({ authFetch }) => {
  const [f, setF] = useState(null);
  useEffect(() => { authFetch('get', '/admin/settings/quote-availability').then(({ data }) => setF(data)).catch((e) => toast.error(errMsg(e))); }, [authFetch]);
  if (!f) return null;
  const save = async () => {
    try {
      const body = Object.fromEntries(FIELDS.map(([k, , t]) => [k, t === 'number' ? parseFloat(f[k]) : f[k]]));
      const { data } = await authFetch('put', '/admin/settings/quote-availability', body);
      setF(data); toast.success('Quote availability settings saved.');
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="rounded-xl border border-slate-200 bg-white p-5 max-w-xl" data-testid="quote-settings">
      <h3 className="font-display text-lg font-extrabold text-[color:var(--mv-navy)]">AI Quote availability settings</h3>
      <p className="text-xs text-slate-500 mb-3">Private — never shown to customers. An enquiry is declined only when the collection is more than the collection threshold from the reference AND the delivery is at least the outward threshold further out, unless the quote is above the exception value. Live driver, van and crew availability is always checked.</p>
      {FIELDS.map(([k, l, t]) => (
        <label key={k} className="block mb-3 text-xs font-bold text-slate-600">{l}
          <input type={t} value={f[k] ?? ''} onChange={(e) => setF({ ...f, [k]: e.target.value })} className="mt-1 block w-full h-10 rounded-md border border-slate-200 px-3 text-sm" data-testid={`qs-${k}`} />
        </label>
      ))}
      <button type="button" onClick={save} className="h-10 px-5 rounded-md bg-[color:var(--mv-navy)] text-white text-sm font-bold" data-testid="qs-save">Save settings</button>
    </div>
  );
};
